export default __webpack_public_path__ + "static/media/issste.d1f04939.jpg";